import { SubjectManager } from "../../../../utils/subjectManager";

export const sharingInformationService = new SubjectManager()